/**
 * iinkJSを利用するディレクティブの directive.link を実現するクラス。
 * ※他の link モジュールはこれを継承する
 * 
 * ※Angularモジュールだと個別インスタンスとして開発しにくいので通常のJSクラスで実装した
 * 
 */
 export default class {
  constructor() {
    // link時の情報
    this.element = null;
    this.attrs = {};

    // iinkJS.registerで生成されるエディター
    this.editor = null;
  }

  /**
   * WebSocketを使うかどうかをURLパラメータから求める
   * @returns boolean true if websocket
   */
  isWebSocket() {
    return location.search.indexOf('iink-protocol=websocket') > -1;
  }

  /**
   * iinkJS.register へのオプションの生成
   * @param {*} scope 
   * @param {*} element 
   * @param {*} attrs 
   * @param {*} ctrl 
   */
  createRegistOption (scope, element, attrs, ctrl) {
    return {
      replace: true,
      triggers: {
        exportContent: 'DEMAND',//'QUIET_PERIOD'
      },
      recognitionParams: {
        type: 'TEXT',
        protocol: this.isWebSocket() ? 'WEBSOCKET' : 'REST',
        apiVersion: 'V4',
        server: {
          scheme: 'https',
          host: RECOGNITION.host,
          applicationKey: RECOGNITION.applicationkey,
          hmacKey: RECOGNITION.hmackey,
        },
      }
    };
  }

  /**
   * 筆跡データを取得する場合は、筆跡取得のためのマウスイベントをセットする$elementを返す。
   * @returns $element
   */
  getStrokeCaptureElement() {
    return null;
  }

  /**
   * ディレクティブ破棄の処理
   */
  onDestroy(scope, element, attrs, ctrl) {
    const editorElement = element.get(0)
    if (scope.exportTimer) {
      scope.destroyCallback = true;
      return;
    }

    let $captureElement = this.getStrokeCaptureElement();
    if ($captureElement && $captureElement.get(0)) {
      // $captureElement = angular.element($captureElement.get(0))
      $captureElement.unbind('mousedown', scope.onMouseDown)
      $captureElement.unbind('touchstart', scope.onMouseDown)
      $captureElement.unbind('mouseup', scope.onMouseUp)
      $captureElement.unbind('touchend', scope.onMouseUp)
      $captureElement.unbind('mousemove', scope.onMouseMove)
      $captureElement.unbind('touchmove', scope.onMouseMove)
      $captureElement.unbind('mouseleave', scope.onMouseLeave)
    }

    editorElement.removeEventListener('loaded', this.onLoaded);
    element.off('$destroy', this.onUnmounted);

    if (typeof scope.onDestroy == 'function') {
      scope.onDestroy(element);
    }

    // 以下、手書き入力欄が消去されてからAPI応答のために必要
    editorElement.removeEventListener('exported', scope.onExported)
    scope.editor = null;
    scope.element = null;
    scope.link = null;

    this.element = null;
    this.attrs = null;
    this.editor = null;
  }

  setEventListener(scope, element, attrs, ctrl) {
    const editorElement = element.get(0)

    // コンテクストメニューの禁止
    if (location.href.indexOf('://localhost') === -1) {
      editorElement.oncontextmenu = () => false;
    }

    // ディレクティブ破棄の処理　↑のイベント削除など
    element.on('$destroy', this.onUnmounted);

    // iinkJSのDOM生成直後の処理
    editorElement.addEventListener('loaded', this.onLoaded);

    // 認識結果受け取り後の処理
    editorElement.addEventListener('exported', scope.onExported)

    // エディターのDOMのマウスイベントはiinkjsが握ってるので、違うDOMに Mouse* のイベントを付与する
    let $captureElement = this.getStrokeCaptureElement();
    if ($captureElement && $captureElement.get(0)) {
      $captureElement = angular.element($captureElement.get(0))
      $captureElement.bind('mousedown', scope.onMouseDown)
      $captureElement.bind('touchstart', scope.onMouseDown)
      $captureElement.bind('mouseup', scope.onMouseUp)
      $captureElement.bind('touchend', scope.onMouseUp)
      $captureElement.bind('mousemove', scope.onMouseMove)
      $captureElement.bind('touchmove', scope.onMouseMove)
      $captureElement.bind('mouseleave', scope.onMouseLeave)
    }
  }

  /**
   * iinkJSのDOM生成後の処理。
   * リサイズとStyle調整。
   * @param {*} scope 
   * @param {*} element 
   * @param {*} attrs 
   * @param {*} ctrl 
   */
  onEditorLoaded(scope, element, attrs, ctrl) {
    if (this.editor) {
      // iinkJSのDOMにリサイズを通知する
      this.editor.resize();
      // iinkJSのDOMスタイル調整
      this.setStyle(scope, element, attrs, ctrl)
      // scope
      scope.editor = this.editor;
    }
  }

  /**
   * iinkJSのDOM生成後のスタイル設定
   * @param {*} scope 
   * @param {*} element 
   * @param {*} attrs 
   * @param {*} ctrl 
   */
  setStyle(scope, element, attrs, ctrl) {
      // style
      // editorElement.editor.penStyle({//documents では関数だが実際にはプロパティ
      const style = {};
      if (attrs.strokecolor) {
        style.color = attrs.strokecolor;
      }
      if (attrs.strokewidth) {
        style['-myscript-pen-width'] = attrs.strokewidth;
      }
      this.editor.penStyle = Object.assign(style, this.editor.penStyle || {});

      // Document記載のやり方↓　そもそも関数じゃない。
      // editorElement.editor.theme({'.greenThickPen' : { "font-family": 'Open Sans', color: '#00FF00', '-myscript-pen-width': 1.5 }});
      // editorElement.editor.penStyleClasses("greenThickPen");
      // editorElement.editor.theme['.greenThickPen'] = {
      //   "font-family": R.fontFamily,//効かない
      //   color: attrs.strokecolor,
      //   '-myscript-pen-width': attrs.strokewidth
      // }
      // editorElement.editor.penStyleClasses = "greenThickPen";
  }

  /**
   * directive.link: DOM生成
   * @param {*} $scope 
   */
  link (scope, element, attrs, ctrl, compile) {
    this.element = element;
    this.attrs = attrs;
    this.onLoaded = () => this.onEditorLoaded(scope, element, attrs, ctrl);
    this.onUnmounted = () => this.onDestroy(scope, element, attrs, ctrl);
    
    // scope.element
    scope.element = element;
    scope.link = this;

    //
    // iinkJS.register へのオプション
    //
    const option = this.createRegistOption(scope, element, attrs, ctrl);

    // 暫定: Triggerのタイミング検証用
    let match = location.search.match(/[?&]{1}delay=(\d+)/i);
    if (match) {
      scope.delay = Number(match[1]);
    }
    else {
      scope.delay = RECOGNITION.slow_timeout;
    }

    console.log(option);
    // console.log('delay: ' + scope.delay);

    // iinkJSへの登録
    const editorElement = element.get(0)
    iink.register(editorElement, option);

    // editor をメンバーにセット
    this.editor = editorElement.editor;

    // イベント設定
    this.setEventListener(scope, element, attrs, ctrl, compile);
  };

  // iinkjs.editor.clear 置換
  clearCanvas() {
    if (this.editor) {
      this.editor.clear();
    }
    this.element.find('canvas.ms-canvas').each((i,canvas) => {
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, ctx.canvas.clientWidth, ctx.canvas.clientHeight)
    });
  }
}